import Repository from '../Repository';

const url = '/admin/blog/posts';

export default {
    getBlogPosts(page = 1) {
        return Repository.get(`${url}/?page=${page}`);
    },

    getPost(id) {
        return Repository.get(`${url}/${id}`);
    },

    createPost(payload) {
        return Repository.post(`${url}`, payload);
    },

    updatePost(id, payload) {
        return Repository.post(`${url}/${id}`, payload);
    },

    deletePost(id) {
        return Repository.delete(`${url}/${id}`);
    }

}
